/**
 * 搜索关键词高亮纯函数（召回测试/全局搜索的 <mark> 标注）。
 * node:test 直接断言，无 Vue/DOM 依赖。
 */

function escapeHtml(text) {
  return String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function escapeRegExp(text) {
  return String(text).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

/**
 * 查询分词：整串 + 按空白/中英文标点切分（保留 ≥2 字符的词）。
 * CJK 连续短语靠"整串"兜底命中；英文按词命中。
 * @param {string} query
 * @returns {string[]} 去重后的词列表（按长度降序，长词优先匹配）
 */
export function tokenizeQuery(query) {
  const q = String(query ?? '').trim()
  if (!q) return []
  const parts = q.split(/[\s,，。.;；:：!！?？、/\\|"'`~@#$%^&*()\-_=+[\]{}<>]+/).filter(Boolean)
  const terms = new Set()
  if (q.length >= 2) terms.add(q)
  for (const p of parts) {
    if (p.length >= 2) terms.add(p)
  }
  return [...terms].sort((a, b) => b.length - a.length)
}

/**
 * 转义文本后按查询词包 <mark>（大小写不敏感，单遍替换避免嵌套）。
 * @param {string} text 原文（未转义）
 * @param {string} query 查询串
 * @returns {string} 可直接 v-html/v-safe-html 的 HTML
 */
export function highlightText(text, query) {
  const escaped = escapeHtml(text)
  const terms = tokenizeQuery(query)
  if (!terms.length) return escaped
  const pattern = terms.map(escapeRegExp).map(t => t.replace(/ /g, '\\s*')).join('|')
  if (!pattern) return escaped
  try {
    return escaped.replace(new RegExp(pattern, 'gi'), (m) => `<mark>${m}</mark>`)
  } catch {
    return escaped
  }
}
